<div aria-live="assertive" aria-atomic="true" class="cdk-visually-hidden">
  {{ stepAnnouncement }}
</div>
<mat-stepper
  linear
  class="stepper"
  #stepper
  (selectionChange)="onStepChange($event)"
>
  @for (item of dataSource; track item; let i = $index) {
    <mat-step>
      <app-evaluation-respond-item
        [source]="item"
        [isPrivate]="isPrivate"
        (downloadFile)="downloadFile($event, item.evaluatee.seatId)"
      >
      </app-evaluation-respond-item>
      @if (dataSource.length == 1) {
        <div
          id="single-submit-button"
          class="button-section"
          fxFlex
          fxLayout="column"
          fxLayoutAlign="center center"
        >
          <button
            mat-flat-button
            type="button"
            class="mat-primary submit-button"
            matStepperNext
            (click)="submit()"
            [disabled]="!isValidEvaluation || isSaving"
          >
            <div fxFlex fxLayout="row" fxLayoutAlign="center center">
              <mat-icon>done</mat-icon>
              <span>Submit</span>
            </div>
          </button>
        </div>
      }
      @if (dataSource.length > 1) {
        <div id="multi-buttons" class="button-section" fxFlex fxLayout="column">
          <div fxFlex fxLayout="row" fxLayoutAlign="space-between center">
            <div fxFlex fxLayoutAlign="end none" class="nav-right">
              @if (i != dataSource.length - 1) {
                <button
                  [id]="'next-button-' + i"
                  mat-flat-button
                  type="button"
                  class="mat-primary next-button"
                  matStepperNext
                  (click)="onClick()"
                  [disabled]="!item.isValid"
                >
                  <div fxFlex fxLayout="row" fxLayoutAlign="center center">
                    <span>Next</span>
                    <mat-icon>arrow_forward</mat-icon>
                  </div>
                </button>
              } @else {
                <button
                  [id]="'submit-button-' + i"
                  mat-flat-button
                  type="button"
                  class="mat-primary submit-button"
                  matStepperNext
                  (click)="submit()"
                  [disabled]="!isValidEvaluation || isSaving"
                >
                  <div fxFlex fxLayout="row" fxLayoutAlign="center center">
                    <mat-icon>done</mat-icon>
                    <span>Submit</span>
                  </div>
                </button>
              }
            </div>
            <div class="nav-center">
              <span>Page {{ i + 1 }} of {{ dataSource.length }}</span>
            </div>
            <div fxFlex fxLayoutAlign="start none" class="nav-left">
              @if (i != 0) {
                <button
                  [id]="'back-button-' + i"
                  mat-flat-button
                  type="button"
                  fxLayoutAlign="start none"
                  matStepperPrevious
                  class="back-button"
                  (click)="onClick()"
                >
                  <div fxFlex fxLayout="row" fxLayoutAlign="center center">
                    <mat-icon>arrow_back</mat-icon>
                    <span>Back</span>
                  </div>
                </button>
              }
            </div>
          </div>
        </div>
      }
    </mat-step>
  }
</mat-stepper>
